import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from 'lib/widgets/Icon/Icon';
import { priceFormat, priceFormatSeparate } from 'apps/products/utils/priceFormat';

const BasketSummary = ({ basket }) => {
  const [basketValue, basketValueFraction] = priceFormatSeparate({ value: basket.value, inPound: true });
  const savings = priceFormat({ value: basket.offerSavings, inPound: true });
  const isLargeOrder = basket.numberOfItems >= 100;
  const basketClassNames = classNames(
    'hd-basketSummary__countValue',
    { 'hd-basketSummary__countValue--largeOrder': isLargeOrder }
  );

  return (
    <>
      <div className="hd-basketSummary__count" key="hd-basketSummary__count">
        <span className={basketClassNames}>
          {basket.numberOfItems}
        </span>
      </div>
      <div className="hd-basketSummary__total" key="hd-basketSummary__total">
        {basketValue}<span className="hd-basketSummary__totalFraction">{basketValueFraction}</span>
      </div>
      <div className="hd-basketSummary__offer" key="hd-basketSummary__offer">
        Savings <span className="hd-basketSummary__offerValue">{savings}</span>
      </div>
      <Icon name="chevron-down" className="hd-basketSummary__chevronDown" key="hd-basketSummary__chevronDown" />
    </>
  );
};

BasketSummary.propTypes = {
  basket: PropTypes.shape({
    value: PropTypes.number.isRequired,
    minimumOrderValue: PropTypes.number.isRequired,
    numberOfItems: PropTypes.number.isRequired,
    offerSavings: PropTypes.number.isRequired,
  }).isRequired,
};

export default BasketSummary;
